export default __webpack_public_path__ + "static/media/main-slide-02.16883608.png";